import {
  DEFAULT_BOX_SHADOW,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  PRIMARY_BACKGROUND,
  TYPE_INSTANCE1,
} from "App/constants";
import { InputTextMaster, MasterButton } from "App/Component/ui";
import { Grid, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";
import { SearchIcon } from "App/Assets";
import ModalBridge from "../Poliklinik/ModalBridge";
import { getDataPoliklinikBridge } from "../Poliklinik/helpers";

export const RESET_STATE_SPESIALIS = {
  id: "",
  name: "",
  code: "",
  codebridgepolibpjs: "",
  codebridgesubspesialist: "",
};
export const deleteSpesialistById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      LIST_URL_MASTER.spesialis.delete,
      {},
      {
        headers: {
          idspesialist: id,
        },
      }
    );

    const newData = await fetchData(
      TYPE_INSTANCE1,
      LIST_URL_MASTER.spesialis.list
    );
    setRows(newData);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_SPESIALIS);
    return defaultToastSuccess("Data Berhasil Dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
  },
  {
    id: "codebridgepolibpjs",
    disablePadding: false,
    label: "BRIDGE POLI BPJS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ formData, setFormData, setRows }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [showModalBridge, setShowModalBridge] = useState(false);
  const [rowsBridge, setRowsBridge] = useState([]);
  const addSpesialist = async () => {
    return instance1.post(LIST_URL_MASTER.spesialis.add, {
      ...formData,
    });
  };

  const updateSpesialist = () => {
    return instance1.post(
      LIST_URL_MASTER.spesialis.update,
      {
        ...formData,
      },
      {
        headers: {
          idspesialist: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.name === "" || formData.code === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama dan Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addSpesialist();
        } else if (formData.id !== "") {
          await updateSpesialist();
        }

        const newData = await fetchData(
          TYPE_INSTANCE1,
          LIST_URL_MASTER.spesialis.list
        );
        setRows(newData);
        setFormData(RESET_STATE_SPESIALIS);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const setNewDataPoliklinikBridge = async () => {
    const res = await getDataPoliklinikBridge();
    if (res.state) {
      setRowsBridge(res.data);
    } else {
      setRowsBridge([]);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewDataPoliklinikBridge();
    })();
  }, []);

  return (
    <Paper
      style={{
        width: "100%",
        margin: "0",
        padding: "1rem 1.5rem",
        backgroundColor: PRIMARY_BACKGROUND,
        boxShadow: DEFAULT_BOX_SHADOW,
      }}>
      {showModalBridge && (
        <ModalBridge
          rowsBridge={rowsBridge}
          setRowsBridge={setRowsBridge}
          formData={formData}
          setFormData={setFormData}
          setShowModal={() => setShowModalBridge(false)}
        />
      )}
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name='code'
              label='Kode'
              id='code'
              value={formData.code}
              onChange={handleChange("code")}
              placeholder='Kode'
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='codebridgepolibpjs'
              label='BRIDGE POLI BPJS'
              id='codebridgepolibpjs'
              value={formData.codebridgepolibpjs}
              placeholder='Pilih Kode Bridge'
              disabled={true}
              withButton={true}>
              <button
                type={"button"}
                onClick={() => setShowModalBridge(!showModalBridge)}
                style={{
                  borderRight: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderLeft: "0",
                  background: "#fff",
                  padding: "0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "0 6px 6px 0",
                }}>
                <SearchIcon width={"16"} height={"16"} fill={"#333"} />
              </button>
            </InputTextMaster>
          </Grid>
        </Grid>

        <div className='mt-1'>
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <MasterButton
              className={"mt-1"}
              type='button'
              color={"danger"}
              name={"RESET"}
              onClick={() => setFormData(RESET_STATE_SPESIALIS)}
              size='md'
            />
            <MasterButton
              className={"mt-1"}
              type='submit'
              color={disabled.color}
              name={disabled.label}
              size='md'
            />
          </Grid>
        </div>
      </form>
    </Paper>
  );
};
